import { FormattedMessage } from 'react-intl';
import type { UpgradeRequiredDetail } from '@/lib/billing-events';
import { UpgradeDialogPanel } from './UpgradeDialogPanel';

interface ExploreUpgradeDialogContentProps {
    detail: UpgradeRequiredDetail;
    onClose: () => void;
    onViewPlans: () => void;
    canViewPlans: boolean;
}

export function ExploreUpgradeDialogContent({
    detail,
    onClose,
    onViewPlans,
    canViewPlans,
}: ExploreUpgradeDialogContentProps) {
    return (
        <UpgradeDialogPanel
            eyebrow={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000901" defaultMessage="Plan limit reached" />}
            title={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000902" defaultMessage="You've reached this month's limit" />}
            description={detail.message || (
                <FormattedMessage
                    id="a0b1c2d3-1111-4a2b-8c3d-000000000903"
                    defaultMessage="Upgrade to Explore to continue using this feature without waiting for your next monthly reset."
                />
            )}
            benefits={[
                <FormattedMessage key="enrichment" id="a0b1c2d3-1111-4a2b-8c3d-000000000907" defaultMessage="Unlimited AI enrichment for every saved home" />,
                <FormattedMessage key="ranking" id="a0b1c2d3-1111-4a2b-8c3d-000000000908" defaultMessage="Shortlist rankings tailored to your group" />,
            ]}
            cta={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000909" defaultMessage="View Explore plan" />}
            dismissAction={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000910" defaultMessage="I'll wait for the reset" />}
            footer={<FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000911" defaultMessage="Invites stay free · cancel anytime" />}
            onClose={onClose}
            onViewPlans={onViewPlans}
            canViewPlans={canViewPlans}
            limitMeter={{
                label: <FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000904" defaultMessage="Limit reached" />,
                resetLabel: <FormattedMessage id="a0b1c2d3-1111-4a2b-8c3d-000000000905" defaultMessage="resets next cycle" />,
            }}
        />
    );
}